import React, { useEffect } from "react";
import "./dopnft.scss";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import NftPrice from "../../hooks/chinaFunction/nftprice";
import { event } from "jquery";
import { useWeb3React } from "@web3-react/core";
import { API_URL } from "../../utils/ApiUrl";
import axios from "axios";
import { toast } from "react-toastify";
import ApproveNft from "../../hooks/dataFetchers/ApproveNft";
import PurchaseNFTwithEth from "../../hooks/chinaFunction/purchaseNFTwithEth";
import PurchaseNFTwithUsdt from "../../hooks/chinaFunction/purchaseNFTwithUsdt";
import PurchaseNFTwithUsdc from "../../hooks/chinaFunction/puchaseNFTwithUsdc";
import PurchaseNFTwithWbtc from "../../hooks/chinaFunction/purchaseNFTwithWbtc";
import PurchaseNFTwithLink from "../../hooks/chinaFunction/purchaseNftwithLink";
import PurchaseNFTwithPepe from "../../hooks/chinaFunction/purchaseNftwithPepe";
import PurchaseNFTwithUniswape from "../../hooks/chinaFunction/purchaseNftwithUniswape";
import AllowanceNft from "../../hooks/dataFetchers/AllowanceNft";
import ApproveNftTomi from "../../hooks/dataFetchers/ApproveNftTomi";
import PurchaseNFTwithTomi from "../../hooks/chinaFunction/purchaseNftwithTomi";
import ApproveTpl from "../../hooks/dataFetchers/ApproveTpl";
import ApproveTomi from "../../hooks/dataFetchers/ApproveTomi";
import Environment from "../../utils/Environment";
import ApproveTplUsdc from "../../hooks/dataFetchers/ApproveTplUsdc";
import ApproveTplWbtc from "../../hooks/dataFetchers/ApproveTplWbtc";
import AllowanceWbtc from "../../hooks/dataFetchers/AllowanceWbtc";
import ApproveLink from "../../hooks/dataFetchers/ApproveLink";
import ApprovePepe from "../../hooks/dataFetchers/ApprovePepe";
import useWeb3 from "../../hooks/useWeb3";
import ApproveUnisawape from "../../hooks/dataFetchers/ApproveUniswape";
import AllowancePepe from "../../hooks/dataFetchers/AllowancePepe";
import ApproveDop from "../../hooks/dataFetchers/ApproveDop";
import PurchaseNFTwithDop from "../../hooks/chinaFunction/purchaseNftwithDop";
import { saveAddress } from "@sharemint/sdk";
import ApproveGems from "../../hooks/dataFetchers/ApproveGems";
import PurchaseNFTwithGems from "../../hooks/chinaFunction/purchaseNftwithGems";
const DopNft = ({
  price,
  ethPricevalue,
  setShow,
  code,
  setLoarder,
  saleCurrentStaus,
  currentRoundd,
  blanceOfEth,
  balanceeUsdt,
  tomiPrice,
  allowanceTpl,
  tomiAllowance,
  balaceOfTmi,
  alowence,
  sallowance,
  discoundedPriceee,
  tab,
  wbtcCurrentPrice,
  getAllowanceUsdc,
  getAllowanceWbtc,
  balaceOfUsdc,
  balaceOfWbtc,
  timeshow,
  psMaxxCap,
  psmyTotlaPurchasess,
  setMyPsTotlaPurchasess,
  psTotlaPurchasess,
  stakeIndex,
  stakedAmount,
  discountedPriceee,
  round,
  pepePrice,
  linkPricevalue,
  uniPricevalue,
  uniAllowance,
  linkAllowance,
  pepeAllowance,
  balaceOfUnii,
  balaceOfPepee,
  balaceOfLinkk,
  dopAllowance,
  balaceOfDoppp,
  dopPricevalue,
  checkBoxx,
  insurancePer,
  gemsAllowance,
  gemsBalance,
  gemsPrice,
  handleShow2Insurance1,
  setCheckBoxx,
  setCheked3,
  setCheked4,
  handleShow5,
}) => {
  const instiPrice = localStorage?.getItem("price_ins");
  const role = localStorage?.getItem("role_ins");
  const email = localStorage?.getItem("email");
  let ipBuyer = localStorage.getItem("ip");
  let countryBuyer = localStorage.getItem("country");
  let sharemintValue = localStorage.getItem("sharemint");
  // console.log(psMaxxCap, psmyTotlaPurchasess,'psMaxxCap >= psmyTotlaPurchasess');
  // const [allowanceTpl, setAllowance] = useState(null)
  const web3 = useWeb3();
  const { purchaseNFTwithDop } = PurchaseNFTwithDop();
  const { approveDop } = ApproveDop();
  const { approveLink } = ApproveLink();
  const { approvePepe } = ApprovePepe();
  const { approveUnisawape } = ApproveUnisawape();
  const { nftPrice } = NftPrice();
  const { approveTomi } = ApproveTomi();
  const { approveGems } = ApproveGems();
  const { approveTpl } = ApproveTpl();
  const { approveTplUsdc } = ApproveTplUsdc();
  const { approveTplwbtc } = ApproveTplWbtc();
  const { approveNftTomi } = ApproveNftTomi();
  const { allowanceNft } = AllowanceNft();
  const { approveNft } = ApproveNft();
  const { purchaseNFTwithUsdt } = PurchaseNFTwithUsdt();
  const { purchaseNFTwithEth } = PurchaseNFTwithEth();
  const { purchaseNFTwithTomi } = PurchaseNFTwithTomi();
  const { purchaseNFTwithGems } = PurchaseNFTwithGems();
  const { purchaseNFTwithUsdc } = PurchaseNFTwithUsdc();
  const { purchaseNFTwithWbtc } = PurchaseNFTwithWbtc();
  const { purchaseNFTwithLink } = PurchaseNFTwithLink();
  const { purchaseNFTwithUniswape } = PurchaseNFTwithUniswape();
  const { purchaseNFTwithPepe } = PurchaseNFTwithPepe();

  const [count, setCount] = useState(0);
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [count4, setCount4] = useState(0);
  const [count5, setCount5] = useState(0);
  const [arryy, setArry] = useState([]);
  const [mainTag, setMainTag] = useState("ETH");
  const [totalNFT, setTotalNft] = useState(0);
  const [totalClaim, setTotalClaim] = useState(0);
  const [totalUsdt, setUsdt] = useState(0);
  const [totalEth, setEth] = useState(0);
  const [totalTomi, setTomi] = useState(0);
  const [totalGems, setGems] = useState(0);
  const [totalUsdc, setUsdc] = useState(0);
  const [totalWbtc, setWbtc] = useState(0);
  const [totalUni, setUni] = useState(0);
  const [totalPepe, setPepe] = useState(0);
  const [totalLink, setLink] = useState(0);
  const [totalDop, setDop] = useState(0);
  const [check, setCheck] = useState(false);
  const { account } = useWeb3React();
  const [nftPriceArryUsdt, setNftPriceArryUsdt] = useState(0);
  const [nftPriceArryEth, setNftPriceArryEth] = useState([]);
  const [nftPriceArryIndux, setNftPriceArryIndux] = useState([]);
  const [tagImge, setTagImge] = useState("/assets/eth-icon.svg");
  const [totall, settTotal] = useState(0);
  const [totalleth, settTotaleth] = useState(0);

  let imges = [
    // { imge: '/nft-img/1.png' },
    // { imge: '/nft-img/2.png' },
    // { imge: '/nft-img/3.png' },
    // { imge: '/nft-img/4.png' },
    // { imge: '/nft-img/5.png' },
    // { imge: '/nft-img/6.png' },
    // { imge: '/nft-img/7.png' },

    { imge: "/nft-img/77.png" },
    { imge: "/nft-img/66.png" },
    { imge: "/nft-img/55.png" },
    { imge: "/nft-img/44.png" },
    { imge: "/nft-img/33.png" },
    { imge: "/nft-img/22.png" },
    { imge: "/nft-img/11.png" },
  ];
  // console.log(approveTplWbtc,'arryy');
  const handleIncrement = (i) => {
    const newData = [...arryy];
    // console.log(newData,'newData');
    newData[i].count += 1;

    newData[i].dopClaim = (newData[i].usdtPrice * newData[i].count) / price;
    console.log(newData[i].dopClaim, 'newData[i].dopClaim', price);
    setArry(newData);
    disableButtonCheck();
  };

  const handleDecrement = (i) => {
    const newData = [...arryy];

    if (newData[i].count > 0) {
      newData[i].count -= 1;
      newData[i].dopClaim = (newData[i].usdtPrice * newData[i].count) / price;
      setArry(newData);
    }

    disableButtonCheck();
  };

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
  };
  const handleShow2 = () => setShow2(true);

  const nftArry = async () => {
    let dummy = [];
    try {
      for (let a = 0; a < 7; a++) {
        let ab = await nftPrice(a);
        console.log(ab, "nftPrice");
          console.log(ab, dopPricevalue, ab/dopPricevalue, "dopPricevalue");
    
        let x = {
          usdtPrice: ab,
          usdcPrice: ab,
          wbtcPrice: ab / wbtcCurrentPrice,
          ethPrice: ab / ethPricevalue,
          tomiPrice1: ab / tomiPrice,
          linkPrice: ab / linkPricevalue,
          uniPrice: ab / uniPricevalue,
          pepePrice1: ab / pepePrice,
          dopPrice: ab / dopPricevalue,
          gemsPrice1: ab / gemsPrice,
          imge: imges[a].imge,
          count: 0,
          indexV: a,
          dopClaim: 0,
        };
        dummy.push(x);
      }
      setArry(dummy);
      // console.log(dummy,'dummy');
    } catch (err) {
      console.log(err, "err nooor");
    }
  };
  useEffect(() => {
    if (
      ethPricevalue &&
      pepePrice &&
      uniPricevalue &&
      linkPricevalue &&
      dopPricevalue &&
      tomiPrice &&
      gemsPrice

    ) {
      console.log(pepePrice, 'pepePrice');
      // &&pepePrice&&uniPricevalue&&linkPricevalue&&dopPricevalue
      nftArry();
    }
  }, [
    ethPricevalue,
    pepePrice,
    uniPricevalue,
    linkPricevalue,
    dopPricevalue,
    tomiPrice,
    gemsPrice,
  ]);

  // console.log(
  //   ethPricevalue,
  //   pepePrice,
  //   uniPricevalue,
  //   linkPricevalue,
  //   dopPricevalue,
  //   tomiPrice,
  //   gemsPrice,
  //   "    ethPricevalue"
  // );
  useEffect(() => {
    clickMeAgain();
  }, [arryy]);
  const clickMe = () => {
    let a = 0;
    let bb = 0;
    let cc = 0;
    let xx = 0;
    let xx1 = 0;
    let xx2 = 0;
    let xx3 = 0;
    let xx4 = 0;
    let xx5 = 0;
    let xx6 = 0;
    let xx7 = 0;
    let xx8 = 0
    let dun = [];
    let dun1 = [];
    let dun2 = [];
    arryy.map((e) => {
      a = e.count + a;
      bb = e?.dopClaim + bb;

      //    console.log(e.count,e?.ethPrice,cc,'e.count');
      if (e.count > 0) {
        cc = e?.usdtPrice * e.count + cc;
        xx = e?.ethPrice * e.count + xx;
        xx1 = e?.tomiPrice1 * e.count + xx1;
        xx2 = e?.usdcPrice * e.count + xx2;
        xx3 = e?.wbtcPrice * e.count + xx3;
        xx4 = e?.uniPrice * e.count + xx4;
        xx5 = e?.linkPrice * e.count + xx5;
        xx6 = e?.pepePrice1 * e.count + xx6;
        xx8 = e?.dopPrice * e.count + xx8;
        xx7 = e?.gemsPrice1 * e.count + xx7;
      }
      console.log(e.count * e?.dopPrice, 'e.count * e?.dopPrice');
      dun.push(e.count * e?.usdtPrice);
      dun1.push(parseFloat(e.count * e?.ethPrice));
      dun2.push(e.count);
    });

    setGems(xx7);
    setTomi(xx1);
    setUni(xx4);
    setLink(xx5);
    setPepe(xx6);
    setDop(xx8);
    setUsdc(xx2);
    setWbtc(xx3);
    setTotalNft(a);
    setTotalClaim(bb);
    setMyPsTotlaPurchasess(bb + psTotlaPurchasess);
    setEth(xx);
    setUsdt(cc);
    setNftPriceArryEth(dun1);
    let totalSum = dun.reduce((a, b) => a + b, 0);
    setNftPriceArryUsdt(totalSum);
    setNftPriceArryIndux(dun2);
    // console.log(mainTag, 'mainTag');
    // if (mainTag==="USDT"){
    let aa = cc;
    let vv = aa / discountedPriceee;
    let cccc = vv - parseFloat(bb)?.toFixed(2);
    // console.log(aa,vv,cccc,'sdssdsadas');
    settTotal(parseInt(cccc));
    let qq = cc * ethPricevalue;
    let hh = qq / discountedPriceee;
    let nn = hh - parseFloat(bb)?.toFixed(2);
    // console.log(qq, nn, hh, 'sdssdsadas');
    settTotaleth(parseInt(nn));
    // }

    handleShow1();
  };
  const clickMeAgain = () => {
    let a = 0;
    let bb = 0;
    let cc = 0;
    let xx = 0;
    let xx1 = 0;
    let xx2 = 0;
    let xx3 = 0;
    let xx4 = 0;
    let xx5 = 0;
    let xx6 = 0;
    let xx7 = 0;
    let xx8 = 0;
    let dun = [];
    let dun1 = [];
    let dun2 = [];
    arryy.map((e) => {
      a = e.count + a;
      bb = e?.dopClaim + bb;

      //    console.log(e.count,e?.ethPrice,cc,'e.count');
      if (e.count > 0) {
        cc = e?.usdtPrice * e.count + cc;
        xx = e?.ethPrice * e.count + xx;
        xx1 = e?.tomiPrice1 * e.count + xx1;
        xx2 = e?.usdcPrice * e.count + xx2;
        xx3 = e?.wbtcPrice * e.count + xx3;
        xx4 = e?.uniPrice * e.count + xx4;
        xx5 = e?.linkPrice * e.count + xx5;
        xx6 = e?.pepePrice1 * e.count + xx6;
        xx8 = e?.dopPrice * e.count + xx8;
        xx7 = e?.gemsPrice1 * e.count + xx7;
      }
      dun.push(e.count * e?.usdtPrice);
      console.log(e.count * e?.dopPrice, 'e.count * e?.dopPrice');
      dun1.push(parseFloat(e.count * e?.ethPrice));
      dun2.push(e.count);
    });

    setGems(xx7);
    setTomi(xx1);
    setUni(xx4);
    setLink(xx5);
    setPepe(xx6);
    setDop(xx8);
    setUsdc(xx2);
    setWbtc(xx3);
    setTotalNft(a);
    setTotalClaim(bb);
    setMyPsTotlaPurchasess(bb + psTotlaPurchasess);
    setEth(xx);
    setUsdt(cc);
    setNftPriceArryEth(dun1);
    let totalSum = dun.reduce((a, b) => a + b, 0);
    setNftPriceArryUsdt(totalSum);
    setNftPriceArryIndux(dun2);
    // console.log(mainTag, 'mainTag');
    // if (mainTag==="USDT"){
    let aa = cc;
    let vv = aa / discountedPriceee;
    let cccc = vv - parseFloat(bb)?.toFixed(2);
    // console.log(aa,vv,cccc,'sdssdsadas');
    settTotal(parseInt(cccc));
    let qq = cc * ethPricevalue;
    let hh = qq / discountedPriceee;
    let nn = hh - parseFloat(bb)?.toFixed(2);
    // console.log(qq, nn, hh, 'sdssdsadas');
    settTotaleth(parseInt(nn));
    // }
  };
  const disableButtonCheck = () => {
    let b = arryy.find((e) => e.count > 0);
    if (b) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  };
  const submitt = async () => {
    setLoarder(true);
    let config;
    handleClose1()
    confirmBuyBefore();
    if (mainTag == "TOMI") {
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "TOMI",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    } else if (mainTag == "ETH") {
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "ETH",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    } else if (mainTag == "USDC") {
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "USDC",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    } else if (mainTag == "WBTC") {
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "WBTC",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    } else if (mainTag == "UNI") {
      // let pricee= uniPricevalue
      // pricee =parseFloat(pricee).toFixed(6)
      // let amount1 = Math.round((pricee) * 1e12) / 1e12;
      // let nd = web3.utils.toWei(amount1.toString(), "mwei");
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "UNI",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    } else if (mainTag == "LINK") {
      // let pricee= uniPricevalue
      // pricee =parseFloat(pricee).toFixed(6)
      // let amount1 = Math.round((pricee) * 1e12) / 1e12;
      // let nd = web3.utils.toWei(amount1.toString(), "mwei");
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "LINK",
          type: "NFT",
          // isInsured: checkBoxx,
          email: email,
        },
      };
    } else if (mainTag == "DOP") {
      // let pricee= uniPricevalue
      // pricee =parseFloat(pricee).toFixed(6)
      // let amount1 = Math.round((pricee) * 1e12) / 1e12;
      // let nd = web3.utils.toWei(amount1.toString(), "mwei");
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "DOP",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    } else if (mainTag == "PEPE") {
      // let pricee= uniPricevalue
      // pricee =parseFloat(pricee).toFixed(6)
      // let amount1 = Math.round((pricee) * 1e12) / 1e12;
      // let nd = web3.utils.toWei(amount1.toString(), "mwei");
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "PEPE",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    } else if (mainTag === "USDT") {
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "USDT",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    } else {
      config = {
        method: "post",
        url: `${API_URL}users/buy-screx`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "GEMS",
          type: "NFT",
          email: email,
          // isInsured: checkBoxx,
        },
      };
    }

    const postApiRes = await axios(config)
      .then(function (response) {
        return response?.data?.data;
      })
      .catch(function (error) {
        toast.error(error?.response?.data.message);
      });
    // console.log();
    if (mainTag === "USDT") {
      if (sallowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balanceeUsdt >=
                (checkBoxx
                  ? parseFloat(totalUsdt) + parseFloat(totalUsdt) * insurancePer
                  : totalUsdt)
              ) {
                let z = await approveTpl(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithUsdt(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (sharemintValue) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                    }
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalUsdt > sallowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balanceeUsdt >=
                  (checkBoxx
                    ? parseFloat(totalUsdt) +
                    parseFloat(totalUsdt) * insurancePer
                    : totalUsdt)
                ) {
                  let res = await approveNft(0, account);
                  if (res) {
                    let res11 = await approveTpl(10000000, account);

                    if (res11) {
                      let q = await purchaseNFTwithUsdt(
                        postApiRes,
                        currentRoundd,
                        nftPriceArryIndux,
                        price,
                        totalUsdt,
                        blanceOfEth,
                        stakeIndex,
                        checkBoxx,
                        insurancePer
                      );
                      if (q) {
                        saveAddress({
                          slug: "NFA",
                          transactionHash: q?.transactionHash,
                        });
                        confirmBuy(q);
                        alowence();
                        handleShow2();
                        setLoarder(false);
                      }
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balanceeUsdt >=
                  (checkBoxx
                    ? parseFloat(totalUsdt) +
                    parseFloat(totalUsdt) * insurancePer
                    : totalUsdt)
                ) {
                  let q = await purchaseNFTwithUsdt(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    } else if (mainTag === "USDC") {
      if (getAllowanceUsdc === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balaceOfUsdc >=
                (checkBoxx
                  ? parseFloat(totalUsdc) + parseFloat(totalUsdc) * insurancePer
                  : totalUsdc)
              ) {
                let z = await approveTplUsdc(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithUsdc(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalUsdc > getAllowanceUsdc) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfUsdc >=
                  (checkBoxx
                    ? parseFloat(totalUsdc) +
                    parseFloat(totalUsdc) * insurancePer
                    : totalUsdc)
                ) {
                  let res11 = await approveTplUsdc(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithUsdc(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      blanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                      confirmBuy(q);
                      alowence();
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfUsdc >=
                  (checkBoxx
                    ? parseFloat(totalUsdc) +
                    parseFloat(totalUsdc) * insurancePer
                    : totalUsdc)
                ) {
                  let q = await purchaseNFTwithUsdc(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    } else if (mainTag === "WBTC") {
      // console.log(AllowanceWbtc,'AllowanceWbtc');
      if (getAllowanceWbtc === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balaceOfWbtc >=
                (checkBoxx
                  ? parseFloat(totalWbtc) + parseFloat(totalWbtc) * insurancePer
                  : totalWbtc)
              ) {
                let z = await approveTplwbtc(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithWbtc(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalWbtc > getAllowanceWbtc) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfWbtc >=
                  (checkBoxx
                    ? parseFloat(totalWbtc) +
                    parseFloat(totalWbtc) * insurancePer
                    : totalWbtc)
                ) {
                  let res11 = await approveTplwbtc(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithWbtc(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      blanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                      confirmBuy(q);
                      alowence();
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfWbtc >=
                  (checkBoxx
                    ? parseFloat(totalWbtc) +
                    parseFloat(totalWbtc) * insurancePer
                    : totalWbtc)
                ) {
                  let q = await purchaseNFTwithWbtc(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    } else if (mainTag === "UNI") {
      if (uniAllowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balaceOfUnii >=
                (checkBoxx
                  ? parseFloat(totalUni) + parseFloat(totalUni) * insurancePer
                  : totalUni)
              ) {
                let z = await approveUnisawape(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithUniswape(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalUni > uniAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfUnii >=
                  (checkBoxx
                    ? parseFloat(totalUni) + parseFloat(totalUni) * insurancePer
                    : totalUni)
                ) {
                  let res11 = await approveUnisawape(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithUniswape(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      blanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                      confirmBuy(q);
                      alowence();
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfUnii >=
                  (checkBoxx
                    ? parseFloat(totalUni) + parseFloat(totalUni) * insurancePer
                    : totalUni)
                ) {
                  let q = await purchaseNFTwithUniswape(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    } else if (mainTag === "LINK") {
      if (linkAllowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balaceOfLinkk >=
                (checkBoxx
                  ? parseFloat(totalLink) + parseFloat(totalLink) * insurancePer
                  : totalLink)
              ) {
                let z = await approveLink(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithLink(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalLink > linkAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfLinkk >=
                  (checkBoxx
                    ? parseFloat(totalLink) +
                    parseFloat(totalLink) * insurancePer
                    : totalLink)
                ) {
                  let res11 = await approveLink(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithLink(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      blanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                      confirmBuy(q);
                      alowence();
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfLinkk >=
                  (checkBoxx
                    ? parseFloat(totalLink) +
                    parseFloat(totalLink) * insurancePer
                    : totalLink)
                ) {
                  let q = await purchaseNFTwithLink(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    } else if (mainTag === "DOP") {
      if (dopAllowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balaceOfDoppp >=
                (checkBoxx
                  ? parseFloat(totalDop) + parseFloat(totalDop) * insurancePer
                  : totalDop)
              ) {
                let z = await approveDop(10000000, account);
                console.log(z, "zzzz");
                if (z) {
                  let q = await purchaseNFTwithDop(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalDop > dopAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfDoppp >=
                  (checkBoxx
                    ? parseFloat(totalDop) + parseFloat(totalDop) * insurancePer
                    : totalDop)
                ) {
                  let res11 = await approveDop(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithDop(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      blanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                      confirmBuy(q);
                      alowence();
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfDoppp >=
                  (checkBoxx
                    ? parseFloat(totalDop) + parseFloat(totalDop) * insurancePer
                    : totalDop)
                ) {
                  let q = await purchaseNFTwithDop(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    } else if (mainTag === "PEPE") {
      if (pepeAllowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balaceOfPepee >=
                (checkBoxx
                  ? parseFloat(totalPepe) + parseFloat(totalPepe) * insurancePer
                  : totalPepe)
              ) {
                let z = await approvePepe(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithPepe(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalPepe > pepeAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfPepee >=
                  (checkBoxx
                    ? parseFloat(totalPepe) +
                    parseFloat(totalPepe) * insurancePer
                    : totalPepe)
                ) {
                  let res11 = await approvePepe(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithPepe(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      blanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                      confirmBuy(q);
                      alowence();
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfPepee >=
                  (checkBoxx
                    ? parseFloat(totalPepe) +
                    parseFloat(totalPepe) * insurancePer
                    : totalPepe)
                ) {
                  let q = await purchaseNFTwithPepe(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    } else if (mainTag === "ETH") {
      if (postApiRes) {
        if (saleCurrentStaus) {
          // console.log(blanceOfEth,totalEth,'khna',blanceOfEth<totalEth);
          if (
            blanceOfEth >
            (checkBoxx
              ? parseFloat(totalEth) + parseFloat(totalEth) * insurancePer
              : totalEth)
          ) {
            // console.log('in function call');
            try {
              let b = blanceOfEth - parseFloat(totalEth);
              let qw = await purchaseNFTwithEth(
                postApiRes,
                currentRoundd,
                nftPriceArryIndux,
                price,
                totalEth,
                b,
                stakeIndex,
                checkBoxx,
                insurancePer
              );
              if (qw) {
                saveAddress({
                  slug: "NFA",
                  transactionHash: qw?.transactionHash,
                });
                confirmBuy(qw);
                handleShow2();
                setLoarder(false);
              }
            } catch (err) {
              console.log(err);
              toast.error("transection reverted");
              setLoarder(false);
            }
          } else {
            toast.error("balance is low");
            setLoarder(false);
          }
        } else {
          toast.error("Sale is Currently Paused");
          setLoarder(false);
        }
      } else {
        console.log("api erro");
        setLoarder(false);
      }
    } else if (mainTag === "TOMI") {
      if (tomiAllowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balaceOfTmi >=
                (checkBoxx
                  ? parseFloat(totalTomi) + parseFloat(totalTomi) * insurancePer
                  : totalTomi)
              ) {
                let z = await approveTomi(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithTomi(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalTomi > tomiAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfTmi >=
                  (checkBoxx
                    ? parseFloat(totalTomi) +
                    parseFloat(totalTomi) * insurancePer
                    : totalTomi)
                ) {
                  let res11 = await approveTomi(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithTomi(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      blanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                      confirmBuy(q);
                      alowence();
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  balaceOfTmi >=
                  (checkBoxx
                    ? parseFloat(totalTomi) +
                    parseFloat(totalTomi) * insurancePer
                    : totalTomi)
                ) {
                  let q = await purchaseNFTwithTomi(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    } else {
      if (gemsAllowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                balaceOfTmi >=
                (checkBoxx
                  ? parseFloat(totalTomi) + parseFloat(totalTomi) * insurancePer
                  : totalTomi)
              ) {
                let z = await approveGems(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithGems(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                toast.error("balance is low");
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      } else {
        try {
          if (totalGems > gemsAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  gemsBalance >=
                  (checkBoxx
                    ? parseFloat(totalGems) +
                    parseFloat(totalGems) * insurancePer
                    : totalGems)
                ) {
                  let res11 = await approveGems(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithGems(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      blanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                      confirmBuy(q);
                      alowence();
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  gemsBalance >=
                  (checkBoxx
                    ? parseFloat(totalGems) +
                    parseFloat(totalGems) * insurancePer
                    : totalGems)
                ) {
                  let q = await purchaseNFTwithGems(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    blanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });
                    confirmBuy(q);
                    alowence();
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  toast.error("balance is low");
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted");
        }
      }
    }
    // handleShow2()
  };
  // const alowence = async () => {
  //     try {
  //       let r = await allowanceNft();
  //     //   console.log( r, 'nooorrr alowance');
  //       setAllowance(r);
  //     //   setAllowance1(r1);
  //     } catch (err) {
  //     }
  //   };
  // useEffect(()=>{
  //     if (account)
  //     {
  //         alowence()
  //     }
  // },[account])

   const confirmBuy = async (dataaa) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        recipient: account,
        price: stakedAmount >= 5555 ? discoundedPriceee : price,
        recipientEmail: email,
        tokenSelected: mainTag,
        privateSale: "SCREX",
        ipAddress: ipBuyer,
        country: countryBuyer,
        dopPurchased: stakedAmount >= 5555 ? totalClaim + totall : totalClaim,
        isInsured: false,
        buyingAmount: mainTag === "USDT"
          ? checkBoxx
            ? parseFloat(
              parseFloat(totalUsdt) + totalUsdt * insurancePer
            )?.toFixed(3)
            : totalUsdt
          : mainTag === "ETH"
            ? checkBoxx
              ? parseFloat(
                parseFloat(totalEth) + totalEth * insurancePer
              )?.toFixed(3)
              : totalEth?.toFixed(3)
            : mainTag === "TOMI"
              ? checkBoxx
                ? parseFloat(
                  parseFloat(totalTomi) + totalTomi * insurancePer
                )?.toFixed(3)
                : totalTomi?.toFixed(3)
              : mainTag === "USDC"
                ? checkBoxx
                  ? parseFloat(
                    parseFloat(totalUsdc) + totalUsdc * insurancePer
                  )?.toFixed(3)
                  : totalUsdc?.toFixed(3)
                : mainTag === "UNI"
                  ? checkBoxx
                    ? parseFloat(
                      parseFloat(totalUni) + totalUni * insurancePer
                    )?.toFixed(3)
                    : totalUni?.toFixed(3)
                  : mainTag === "LINK"
                    ? checkBoxx
                      ? parseFloat(
                        parseFloat(totalLink) + totalLink * insurancePer
                      )?.toFixed(3)
                      : totalLink?.toFixed(3)
                    : mainTag === "PEPE"
                      ? checkBoxx
                        ? parseFloat(
                          parseFloat(totalPepe) + totalPepe * insurancePer
                        )?.toFixed(3)
                        : totalPepe?.toFixed(3)
                      : mainTag === "DOP"
                        ? checkBoxx
                          ? parseFloat(
                            parseFloat(totalDop) + totalDop * insurancePer
                          )?.toFixed(3)
                          : totalDop?.toFixed(3)
                        : mainTag === "WBTC"
                          ? checkBoxx
                            ? parseFloat(
                              parseFloat(totalWbtc) + totalWbtc * insurancePer
                            )?.toFixed(3)
                            : totalWbtc?.toFixed(3)
                          : checkBoxx
                            ? parseFloat(
                              parseFloat(totalGems) + totalGems * insurancePer
                            )?.toFixed(3)
                            : totalGems?.toFixed(3)
        ,
        buyingAmountUsd: checkBoxx
          ? (
            nftPriceArryUsdt +
            nftPriceArryUsdt * insurancePer
          )?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 5,
          })
          : nftPriceArryUsdt?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 5,
          }),
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuyBefore = async () => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    const config = {
      method: "post",
      url: `${API_URL}emails/temp`,
      data: {
        accessCode: code,
        accessCodeRole: role,
        by: account,
        price: stakedAmount >= 5555 ? discoundedPriceee : price,
        recipientEmail: email,
        tokenSelected: mainTag,
        privateSale: "SCREX",
        ipAddress: ipBuyer,
        country: countryBuyer,
        isInsured: false,
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const changeTag1 = (e) => {
    if (e === "ETH") {
      setMainTag("ETH");
      setTagImge("/assets/eth-icon.svg");
      discoundedPriceee(currentRoundd, Environment.eth);
      // setMainTag1("ETH");
      //   setInputField1('');
      //   setInputField('');
      // }
    } else if (e == "USDT") {
      setMainTag("USDT");
      setTagImge("/assets/usdt.svg");
      discoundedPriceee(currentRoundd, Environment.busd);
      // setMainTag1("USDT");
      //   setInputField1('');
      //   setInputField('');
    } else if (e == "USDC") {
      discoundedPriceee(currentRoundd, Environment.usdc);
      setMainTag("USDC");
      setTagImge("/assets/usdc.svg");
    } else if (e == "WBTC") {
      discoundedPriceee(currentRoundd, Environment.wbtc);
      setMainTag("WBTC");
      setTagImge("/assets/wbtc.svg");
    } else if (e == "LINK") {
      discoundedPriceee(currentRoundd, Environment.link);
      setMainTag("LINK");
      setTagImge("/assets/link.svg");
    } else if (e == "DOP") {
      discoundedPriceee(currentRoundd, Environment.dop);
      setMainTag("DOP");
      setTagImge("/assets/dop.svg");
    } else if (e == "UNI") {
      discoundedPriceee(currentRoundd, Environment.unisape);
      setMainTag("UNI");
      setTagImge("/assets/uniswap.svg");
    } else if (e == "PEPE") {
      discoundedPriceee(currentRoundd, Environment.pepe);
      setMainTag("PEPE");
      setTagImge("/assets/pepe.svg");
    } else if (e === "TOMI") {
      setMainTag("TOMI");
      setTagImge("/assets/tomi-icon-drop.svg");
      discoundedPriceee(currentRoundd, Environment.tomi);
      // setMainTag1("USDT");
      //   setInputField1('');
      //   setInputField('');
    } else {
      setMainTag("GEMS");
      setTagImge("/assets/newgemslogosvg.svg");
      discoundedPriceee(currentRoundd, Environment.gems);
      // setMainTag1("USDT");
      //   setInputField1('');
      //   setInputField('');
    }
  };
  useEffect(() => {
    discoundedPriceee(currentRoundd, Environment.eth);
    setMainTag("ETH");
    setTagImge("/assets/eth-icon.svg");
  }, [tab]);
  return (
    <>
      <section className="dop_nft">
        <div class="dropdown select-drop">
          <button
            class="dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="twice">
              <div className="inner-flex">
                <img
                  style={{ width: "18px", height: "18px", objectFit: "cover" }}
                  src={tagImge}
                  alt="img"
                  className="img-fluid"
                />{" "}
                {mainTag}
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="8"
                viewBox="0 0 15 8"
                fill="none"
              >
                <path
                  d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                  fill="#02171D"
                />
                <path
                  d="M15 0.500244L15 3.47081L7.76667 7.50024L7.76667 4.52968L15 0.500244Z"
                  fill="#02171D"
                />
              </svg>
            </div>
          </button>
          {/* <ul class="dropdown-menu">
                        <li><a class="dropdown-item" onClick={() => {
                            setMainTag("USDT")
                        }} ><img src="\assets\usdt-icon.svg" alt="img" className='img-fluid' /> USDT</a></li>
                        <li><a class="dropdown-item" onClick={() => {
                            setMainTag("ETH")
                        }} ><img src="\assets\eth-icon-new.svg" alt="img" className='img-fluid' /> ETH</a></li>
                    </ul> */}
          <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("ETH")}
              >
                <img
                  src="/assets/eth-icon.svg"
                  alt="img"
                  className="img-fluid"
                />{" "}
                ETH
              </a>
            </li>
            <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("USDT")}
              >
                <img src="/assets/usdt.svg" alt="img" className="img-fluid" />{" "}
                USDT
              </a>
            </li>
            <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("USDC")}
              >
                <img src="\assets\usdc.svg" alt="img" className="img-fluid" />{" "}
                USDC
              </a>
            </li>
            <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("GEMS")}
              >
                <img
                  src="\assets\newgemslogosvg.svg"
                  alt="img"
                  className="img-fluid"
                />{" "}
                GEMS
              </a>
            </li>
            <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("WBTC")}
              >
                <img src="\assets\wbtc.svg" alt="img" className="img-fluid" />{" "}
                WBTC
              </a>
            </li>
            <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("LINK")}
              >
                <img src="\assets\link.svg" alt="img" className="img-fluid" />{" "}
                LINK
              </a>
            </li>
            {/* <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("TOMI")}
              >
                <img
                  src="\assets\tomi-icon-drop.svg"
                  alt="img"
                  className="img-fluid"
                />{" "}
                TOMI
              </a>
            </li> */}
            <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("PEPE")}
              >
                <img src="\assets\pepe.svg" alt="img" className="img-fluid" />{" "}
                PEPE
              </a>
            </li>

            <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("UNI")}
              >
                <img
                  src="\assets\uniswap.svg"
                  alt="img"
                  className="img-fluid"
                />{" "}
                UNI
              </a>
            </li>

            {/* <li>
              <a
                class="dropdown-item gscrxcsx"
                onClick={() => changeTag1("DOP")}
              >
                <img src="\assets\dop.svg" alt="img" className="img-fluid" />{" "}
                DOP
              </a>
            </li> */}
          </ul>
        </div>
        <div className="parent-card">
          {arryy.map((e, i) => {
            return (
              <div className="inner-card">
                <div className="upper-img">
                  <img src={e?.imge} alt="img" className="img-fluid" />
                </div>
                <div className="bottom-text">
                  <div className="inner-text">
                    <p>
                      Price{" "}
                      {mainTag === "USDT"
                        ? "USDT"
                        : mainTag === "ETH"
                          ? "ETH"
                          : mainTag === "TOMI"
                            ? "TOMI"
                            : mainTag === "USDC"
                              ? "USDC"
                              : mainTag === "UNI"
                                ? "UNI"
                                : mainTag === "LINK"
                                  ? "LINK"
                                  : mainTag === "PEPE"
                                    ? "PEPE"
                                    : mainTag === "DOP"
                                      ? "DOP"
                                      : mainTag === "WBTC"
                                        ? "WBTC"
                                        : "GEMS"}
                    </p>
                    <h6>
                      {mainTag === "USDT" ? "$" : ""}
                      {mainTag === "USDT"
                        ? e?.usdtPrice
                        : mainTag === "ETH"
                          ? parseFloat(e?.ethPrice).toFixed(4)
                          : mainTag === "TOMI"
                            ? parseFloat(e?.tomiPrice1).toFixed(4)
                            : mainTag === "USDC"
                              ? parseFloat(e?.usdcPrice).toFixed(4)
                              : mainTag === "UNI"
                                ? parseFloat(e?.uniPrice).toFixed(4)
                                : mainTag === "LINK"
                                  ? parseFloat(e?.linkPrice).toFixed(4)
                                  : mainTag === "PEPE"
                                    ? parseFloat(e?.pepePrice1).toFixed(4)
                                    : mainTag === "DOP"
                                      ? parseFloat(e?.dopPrice).toFixed(4)
                                      : mainTag === "WBTC"
                                        ? parseFloat(e?.wbtcPrice).toFixed(4)
                                        : parseFloat(e?.gemsPrice1).toFixed(4)}
                    </h6>
                  </div>
                  <div className="inner-text">
                    <p>Claimable $SCRX</p>
                    <h6>{parseFloat(e?.dopClaim).toFixed(4)}</h6>
                  </div>
                </div>
                <div className="select-nft">
                  <div className="left">
                    {e?.count == 0 ? (
                      <img
                        src="\assets\minusnft.svg"
                        alt="img"
                        className="img-fluid"
                        style={{ opacity: "0.2", pointerEvents: "none" }}
                      />
                    ) : (
                      <img
                        onClick={(event) => handleDecrement(i)}
                        src="\assets\minusnft.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    )}
                  </div>
                  <div className="mid">
                    <h6>{e?.count}</h6>
                  </div>
                  <div className="right">
                    <img
                      onClick={(event) => handleIncrement(i)}
                      src="\assets\plusnft.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* <div className="getinsurance-flow">
          <img
            src="\assets\insurance-bg.png"
            alt="img"
            className="img-fluid insurance-shadow"
          />
          <div className="left-side">
            <div className="lefthead">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M13.5007 9.49826L13.5007 6.79987L9.38942 10.9008L6.93848 9.17174L6.93848 11.6734L9.38941 13.5202L13.5007 9.49826Z"
                  fill="#329879"
                />
                <path
                  d="M15.4004 5.93396L15.4004 3.68436L9.94927 0.63287L9.94927 2.88247L15.4004 5.93396Z"
                  fill="#329879"
                />
                <path
                  d="M4.48633 5.93396L4.48633 3.68436L9.93745 0.632871L10.8798 2.05067L9.93745 2.88248L4.48633 5.93396Z"
                  fill="#329879"
                />
                <path
                  d="M17.1221 10.7532L17.1221 5.93036L15.0664 5.93036L15.0664 10.7532L17.1221 10.7532Z"
                  fill="#329879"
                />
                <path
                  d="M2.7334 10.7532L2.7334 5.93036L4.78902 5.93036L4.78902 10.7532L2.7334 10.7532Z"
                  fill="#329879"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.26893 17.126C12.9144 15.8369 15.176 13.4242 15.0669 10.3578L17.1225 10.4369C17.2772 14.7847 14.0172 17.6273 9.95425 19.064L9.26893 17.126Z"
                  fill="#329879"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.6333 17.126C6.98789 15.8369 4.67972 13.4241 4.7888 10.3578L2.69363 10.4369C2.53896 14.7847 5.88506 17.6273 9.948 19.064L10.6333 17.126Z"
                  fill="#329879"
                />
              </svg>
              <h6 className="protecthead">Gems Protect</h6>
            </div>
            <p>
              Get 75% of your purchase covered by paying just 5% of the total
              cost.{" "}
            </p>
          </div>
          <div className="right-side">
            {!checkBoxx ? (
              <>
                <button
                  onClick={() => handleShow2Insurance1()}
                  className={
                    check ? "addinsurance-btn" : "addinsurance-btn disabled"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.5L19.4 4.5L15.5 11.5H8.5L4.3 2.5H1V4.5H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3Z"
                      fill="#329879"
                    />
                  </svg>{" "}
                  <>
                    {check ? (
                      <>
                        Add for{" "}
                        {mainTag === "USDT"
                          ? parseFloat(totalUsdt * insurancePer)?.toFixed(3)
                          : mainTag === "ETH"
                          ? parseFloat(totalEth * insurancePer)?.toFixed(3)
                          : mainTag === "TOMI"
                          ? parseFloat(totalTomi * insurancePer)?.toFixed(3)
                          : mainTag === "USDC"
                          ? parseFloat(totalUsdc * insurancePer)?.toFixed(3)
                          : mainTag === "UNI"
                          ? parseFloat(totalUni * insurancePer)?.toFixed(3)
                          : mainTag === "LINK"
                          ? parseFloat(totalLink * insurancePer)?.toFixed(3)
                          : mainTag === "PEPE"
                          ? parseFloat(totalPepe * insurancePer)?.toFixed(3)
                          : mainTag === "DOP"
                          ? parseFloat(totalDop * insurancePer)?.toFixed(3)
                          : mainTag === "WBTC"
                          ? parseFloat(totalWbtc * insurancePer)?.toFixed(3)
                          : parseFloat(totalGems * insurancePer)?.toFixed(3)}
                    
                        {mainTag}
                      </>
                    ) : (
                      <>Add Gems Protect</>
                    )}
                  </>
                </button>
              </>
            ) : (
              <>
                <div className="insurance-added">
                  <div className="btn-added">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.50002L19.4 4.50002L15.5 11.5H8.5L4.3 2.50002H1V4.50002H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3ZM18 3.30002L16.6 1.90002L11.8 6.70002L9.2 4.10002L7.8 5.50002L11.8 9.50002L18 3.30002Z"
                        fill="#E2E9EC"
                      />
                    </svg>
                    <h6>Gems Protect Added</h6>
                  </div>
                  <div
                    className="btnnotadded"
                    onClick={() => {
                      setCheckBoxx(false);
                      setCheked3(false);
                      setCheked4(false);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.50002L19.4 4.50002L15.5 11.5H8.5L4.3 2.50002H1V4.50002H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3ZM18 3.30002L16.6 1.90002L11.8 6.70002L9.2 4.10002L7.8 5.50002L11.8 9.50002L18 3.30002Z"
                        fill="#FC4F52"
                      />
                    </svg>
                    <h6>Remove Gems Protect</h6>
                  </div>
                </div>
              </>
            )}
          </div>
        </div> */}
        <div
          className="inner-text-bold mt-3 w-100"
          style={{ flexDirection: "column" }}
        >
          {checkBoxx && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="w-100 mb-3"
            >
              <h6 style={{ color: "#329879" }}>Gems Protect</h6>
              <h6>
                {mainTag === "USDT"
                  ? parseFloat(totalUsdt * insurancePer)?.toFixed(3)
                  : mainTag === "ETH"
                    ? parseFloat(totalEth * insurancePer)?.toFixed(3)
                    : mainTag === "TOMI"
                      ? parseFloat(totalTomi * insurancePer)?.toFixed(3)
                      : mainTag === "USDC"
                        ? parseFloat(totalUsdc * insurancePer)?.toFixed(3)
                        : mainTag === "UNI"
                          ? parseFloat(totalUni * insurancePer)?.toFixed(3)
                          : mainTag === "LINK"
                            ? parseFloat(totalLink * insurancePer)?.toFixed(3)
                            : mainTag === "PEPE"
                              ? parseFloat(totalPepe * insurancePer)?.toFixed(3)
                              : mainTag === "DOP"
                                ? parseFloat(totalDop * insurancePer)?.toFixed(3)
                                : mainTag === "WBTC"
                                  ? parseFloat(totalWbtc * insurancePer)?.toFixed(3)
                                  : parseFloat(totalGems * insurancePer)?.toFixed(3)}{" "}
                <span> {mainTag}</span>{" "}
                <span style={{ fontSize: "18px", color: "#77868B" }}>
                  ($
                  {check
                    ? (nftPriceArryUsdt * insurancePer)?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 5,
                      }
                    )
                    : 0.0}
                  )
                </span>
              </h6>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="w-100"
          >
            <h6 style={{ color: "#329879" }}>Total:</h6>
            <h6>
              <span style={{ color: "#329879" }}>
                {mainTag === "USDT"
                  ? checkBoxx
                    ? parseFloat(
                      parseFloat(totalUsdt) + totalUsdt * insurancePer
                    )?.toFixed(3)
                    : totalUsdt
                  : mainTag === "ETH"
                    ? checkBoxx
                      ? parseFloat(
                        parseFloat(totalEth) + totalEth * insurancePer
                      )?.toFixed(3)
                      : totalEth?.toFixed(3)
                    : mainTag === "TOMI"
                      ? checkBoxx
                        ? parseFloat(
                          parseFloat(totalTomi) + totalTomi * insurancePer
                        )?.toFixed(3)
                        : totalTomi?.toFixed(3)
                      : mainTag === "USDC"
                        ? checkBoxx
                          ? parseFloat(
                            parseFloat(totalUsdc) + totalUsdc * insurancePer
                          )?.toFixed(3)
                          : totalUsdc?.toFixed(3)
                        : mainTag === "UNI"
                          ? checkBoxx
                            ? parseFloat(
                              parseFloat(totalUni) + totalUni * insurancePer
                            )?.toFixed(3)
                            : totalUni?.toFixed(3)
                          : mainTag === "LINK"
                            ? checkBoxx
                              ? parseFloat(
                                parseFloat(totalLink) + totalLink * insurancePer
                              )?.toFixed(3)
                              : totalLink?.toFixed(3)
                            : mainTag === "PEPE"
                              ? checkBoxx
                                ? parseFloat(
                                  parseFloat(totalPepe) + totalPepe * insurancePer
                                )?.toFixed(3)
                                : totalPepe?.toFixed(3)
                              : mainTag === "DOP"
                                ? checkBoxx
                                  ? parseFloat(
                                    parseFloat(totalDop) + totalDop * insurancePer
                                  )?.toFixed(3)
                                  : totalDop?.toFixed(3)
                                : mainTag === "WBTC"
                                  ? checkBoxx
                                    ? parseFloat(
                                      parseFloat(totalWbtc) + totalWbtc * insurancePer
                                    )?.toFixed(3)
                                    : totalWbtc?.toFixed(3)
                                  : checkBoxx
                                    ? parseFloat(
                                      parseFloat(totalGems) + totalGems * insurancePer
                                    )?.toFixed(3)
                                    : totalGems?.toFixed(3)}
              </span>{" "}
              <span style={{ color: "#329879" }}> {mainTag}</span>{" "}
              <span style={{ fontSize: "18px", color: "#77868B" }}>
                ($
                {check ? (
                  <>
                    {checkBoxx
                      ? (
                        nftPriceArryUsdt +
                        nftPriceArryUsdt * insurancePer
                      )?.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 5,
                      })
                      : nftPriceArryUsdt?.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 5,
                      })}
                  </>
                ) : (
                  0.0
                )}
                )
              </span>
            </h6>
          </div>
        </div>

        <div className="bottom-btn">
          {account ? (
            <>
              {!timeshow ? (
                <>
                  {check ? (
                    <button onClick={clickMe} className="btn-buy-nft">
                      Buy NFTs
                    </button>
                  ) : (
                    <button className="btn-buy">Buy NFTs</button>
                  )}
                </>
              ) : (
                <button className="btn-buy">Buy NFTs</button>
              )}
            </>
          ) : (
            <button className="btn-buy">Buy NFTs</button>
          )}

          {/* </>
            :
            <button onClick={() => {
              setShow(true)
            }} className="btn-buy">Buy NFTs</button>
          } */}
        </div>
      </section>

      <Modal
        className="connectwallet-modal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Buy NFTs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buydopnft-modal">
            <div className="inner-text">
              <p>No. of NFTs</p>
              <h6>{totalNFT}</h6>
            </div>
            <div className="inner-text">
              <p>$SCRX Price</p>
              <h6>
                ${stakedAmount >= 5555 ? discountedPriceee?.toFixed(8) : price}
              </h6>
            </div>
            <div className="inner-text">
              <p>
                Total in{" "}
                {mainTag === "USDT"
                  ? "USDT"
                  : mainTag === "ETH"
                    ? "ETH"
                    : mainTag === "TOMI"
                      ? "TOMI"
                      : mainTag === "USDC"
                        ? "USDC"
                        : mainTag === "UNI"
                          ? "UNI"
                          : mainTag === "LINK"
                            ? "LINK"
                            : mainTag === "PEPE"
                              ? "PEPE"
                              : mainTag === "DOP"
                                ? "DOP"
                                : mainTag === "WBTC"
                                  ? "WBTC"
                                  : "GEMS"}
              </p>
              <h6>
                {mainTag === "USDT"
                  ? checkBoxx
                    ? parseFloat(
                      parseFloat(totalUsdt) + totalUsdt * insurancePer
                    )?.toFixed(3)
                    : totalUsdt
                  : mainTag === "ETH"
                    ? checkBoxx
                      ? parseFloat(
                        parseFloat(totalEth) + totalEth * insurancePer
                      )?.toFixed(3)
                      : totalEth?.toFixed(3)
                    : mainTag === "TOMI"
                      ? checkBoxx
                        ? parseFloat(
                          parseFloat(totalTomi) + totalTomi * insurancePer
                        )?.toFixed(3)
                        : totalTomi?.toFixed(3)
                      : mainTag === "USDC"
                        ? checkBoxx
                          ? parseFloat(
                            parseFloat(totalUsdc) + totalUsdc * insurancePer
                          )?.toFixed(3)
                          : totalUsdc?.toFixed(3)
                        : mainTag === "UNI"
                          ? checkBoxx
                            ? parseFloat(
                              parseFloat(totalUni) + totalUni * insurancePer
                            )?.toFixed(3)
                            : totalUni?.toFixed(3)
                          : mainTag === "LINK"
                            ? checkBoxx
                              ? parseFloat(
                                parseFloat(totalLink) + totalLink * insurancePer
                              )?.toFixed(3)
                              : totalLink?.toFixed(3)
                            : mainTag === "PEPE"
                              ? checkBoxx
                                ? parseFloat(
                                  parseFloat(totalPepe) + totalPepe * insurancePer
                                )?.toFixed(3)
                                : totalPepe?.toFixed(3)
                              : mainTag === "DOP"
                                ? checkBoxx
                                  ? parseFloat(
                                    parseFloat(totalDop) + totalDop * insurancePer
                                  )?.toFixed(3)
                                  : totalDop?.toFixed(3)
                                : mainTag === "WBTC"
                                  ? checkBoxx
                                    ? parseFloat(
                                      parseFloat(totalWbtc) + totalWbtc * insurancePer
                                    )?.toFixed(3)
                                    : totalWbtc?.toFixed(3)
                                  : checkBoxx
                                    ? parseFloat(
                                      parseFloat(totalGems) + totalGems * insurancePer
                                    )?.toFixed(3)
                                    : totalGems?.toFixed(3)}
              </h6>
            </div>
            {/* <div className="inner-text">
              <p>sub total Claimable $SCREX</p>
              <h6>{parseFloat(totalClaim)?.toFixed(4)}{" "}$SCREX</h6>
            </div> */}
            {/* <div className="inner-text">
              <p>{round == 1 ? '20' : "7"}% Additional Tokens:Claimable $SCREX</p>
              <h6>{stakedAmount >= 5555 ?
                parseFloat(totall)?.toFixed(4)
                : 0.00
              }{" "}$SCREX</h6>
            </div> */}
            <div className="inner-text">
              <p>total Claimable $SCRX</p>
              <h6>
                {stakedAmount >= 5555
                  ? (totall + totalClaim).toFixed(2)
                  : parseFloat(totalClaim)?.toFixed(4)}{" "}
                $SCRX
              </h6>
            </div>
          </div>
          <div className="twice-btnsss">
            <button onClick={handleClose1} className="btn-backkk">
              Back
            </button>

            <button onClick={submitt} className="btn-proceed ">
              proceed
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* 
      <Modal
        className="connectwallet-modal"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Buy NFTs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buydopnft-modal buynft-modal2">
            <img src="\assets\happyface.svg" alt="img" className="img-fluid" />
            <h5>
              You have successfully purchased{" "}
              <span>
                {" "}
                {totalNFT} $SCREX {totalNFT > 0 ? "NFT" : "NFTs"}
              </span>{" "}
              worth{" "}
              <span>
                {" "}
                {stakedAmount >= 5555
                  ? (totall + totalClaim).toFixed(2)
                  : parseFloat(totalClaim)?.toFixed(4)}{" "}
                $SCREX
              </span>
            </h5>
          </div>
          <div className="twice-btnsss">
            <button
              onClick={handleClose2}
              className="btn-proceed sscscscscscsc"
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal> */}

      <Modal
        className="connectwallet-modal buy-modal trx-modal"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>$SCRX Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-modal">
            <img src="\assets\purchased.svg" alt="img" className="img-fluid" />
            <h4>Tokens Successfully Purchased</h4>
            <p>You have successfully purchased Tokens</p>
            <div className="token-purchased-area">
              <div className="single-value">
                <h5>Tokens Purchased</h5>
                <h6>
                  {stakedAmount >= 5555
                    ? (totall + totalClaim).toFixed(2)
                    : parseFloat(totalClaim)?.toFixed(4)}{" "}
                  $SCRX
                </h6>
              </div>
            </div>
            <div className="token-purchased-area tokenpurchasedlast">
              {checkBoxx && (
                <div className="single-value">
                  <h5 style={{ color: "#329879" }}>Spent on Token Purchase</h5>
                  <h6>
                    <span style={{ color: "#329879" }}>
                      {mainTag === "USDT"
                        ? totalUsdt
                        : mainTag === "ETH"
                          ? totalEth?.toFixed(3)
                          : mainTag === "TOMI"
                            ? totalTomi?.toFixed(3)
                            : mainTag === "USDC"
                              ? totalUsdc?.toFixed(3)
                              : mainTag === "UNI"
                                ? totalUni?.toFixed(3)
                                : mainTag === "LINK"
                                  ? totalLink?.toFixed(3)
                                  : mainTag === "PEPE"
                                    ? totalPepe?.toFixed(3)
                                    : mainTag === "DOP"
                                      ? totalDop?.toFixed(3)
                                      : mainTag === "WBTC"
                                        ? totalWbtc?.toFixed(3)
                                        : totalGems?.toFixed(3)}
                    </span>{" "}
                    <span style={{ color: "#329879" }}> {mainTag}</span>{" "}
                    <span style={{ fontSize: "18px", color: "#77868B" }}>
                      ($
                      {check
                        ? nftPriceArryUsdt?.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        })
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              {checkBoxx && (
                <div className="single-value">
                  <h5 style={{ color: "#329879" }}>Gems Protect</h5>
                  <h6>
                    {mainTag === "USDT"
                      ? parseFloat(totalUsdt * insurancePer)?.toFixed(3)
                      : mainTag === "ETH"
                        ? parseFloat(totalEth * insurancePer)?.toFixed(3)
                        : mainTag === "TOMI"
                          ? parseFloat(totalTomi * insurancePer)?.toFixed(3)
                          : mainTag === "USDC"
                            ? parseFloat(totalUsdc * insurancePer)?.toFixed(3)
                            : mainTag === "UNI"
                              ? parseFloat(totalUni * insurancePer)?.toFixed(3)
                              : mainTag === "LINK"
                                ? parseFloat(totalLink * insurancePer)?.toFixed(3)
                                : mainTag === "PEPE"
                                  ? parseFloat(totalPepe * insurancePer)?.toFixed(3)
                                  : mainTag === "DOP"
                                    ? parseFloat(totalDop * insurancePer)?.toFixed(3)
                                    : mainTag === "WBTC"
                                      ? parseFloat(totalWbtc * insurancePer)?.toFixed(3)
                                      : parseFloat(totalGems * insurancePer)?.toFixed(3)}{" "}
                    {mainTag}{" "}
                    <span style={{ fontSize: "18px", color: "#77868B" }}>
                      ($
                      {check
                        ? (nftPriceArryUsdt * insurancePer)?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 5,
                          }
                        )
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              <div className="single-value">
                <h5 style={{ color: "#329879" }}>Total Amount Spent</h5>
                <h6>
                  {mainTag === "USDT"
                    ? checkBoxx
                      ? parseFloat(
                        parseFloat(totalUsdt) + totalUsdt * insurancePer
                      )?.toFixed(3)
                      : totalUsdt
                    : mainTag === "ETH"
                      ? checkBoxx
                        ? parseFloat(
                          parseFloat(totalEth) + totalEth * insurancePer
                        )?.toFixed(3)
                        : totalEth?.toFixed(3)
                      : mainTag === "TOMI"
                        ? checkBoxx
                          ? parseFloat(
                            parseFloat(totalTomi) + totalTomi * insurancePer
                          )?.toFixed(3)
                          : totalTomi?.toFixed(3)
                        : mainTag === "USDC"
                          ? checkBoxx
                            ? parseFloat(
                              parseFloat(totalUsdc) + totalUsdc * insurancePer
                            )?.toFixed(3)
                            : totalUsdc?.toFixed(3)
                          : mainTag === "UNI"
                            ? checkBoxx
                              ? parseFloat(
                                parseFloat(totalUni) + totalUni * insurancePer
                              )?.toFixed(3)
                              : totalUni?.toFixed(3)
                            : mainTag === "LINK"
                              ? checkBoxx
                                ? parseFloat(
                                  parseFloat(totalLink) + totalLink * insurancePer
                                )?.toFixed(3)
                                : totalLink?.toFixed(3)
                              : mainTag === "PEPE"
                                ? checkBoxx
                                  ? parseFloat(
                                    parseFloat(totalPepe) + totalPepe * insurancePer
                                  )?.toFixed(3)
                                  : totalPepe?.toFixed(3)
                                : mainTag === "DOP"
                                  ? checkBoxx
                                    ? parseFloat(
                                      parseFloat(totalDop) + totalDop * insurancePer
                                    )?.toFixed(3)
                                    : totalDop?.toFixed(3)
                                  : mainTag === "WBTC"
                                    ? checkBoxx
                                      ? parseFloat(
                                        parseFloat(totalWbtc) + totalWbtc * insurancePer
                                      )?.toFixed(3)
                                      : totalWbtc?.toFixed(3)
                                    : checkBoxx
                                      ? parseFloat(
                                        parseFloat(totalGems) + totalGems * insurancePer
                                      )?.toFixed(3)
                                      : totalGems?.toFixed(3)}{" "}
                  {mainTag}{" "}
                  <span style={{ fontSize: "18px", color: "#77868B" }}>
                    ($
                    {check ? (
                      <>
                        {checkBoxx
                          ? (
                            nftPriceArryUsdt +
                            nftPriceArryUsdt * insurancePer
                          )?.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 5,
                          })
                          : nftPriceArryUsdt?.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 5,
                          })}
                      </>
                    ) : (
                      0.0
                    )}
                    )
                  </span>
                </h6>
              </div>
            </div>

            <button
              className="btn-common"
              onClick={() => {
                handleClose2();
                handleShow5();
                window.location.reload()

              }}
              style={{ marginTop: "20px" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DopNft;
